import { RoleType, roleTypeSchema, userAccountSchema } from 'api-validations/user-api'
import { type ApiClient, useApiClient, useQuery } from 'shared-ui/api-provider'
import { type ApiError, throwIfNil } from 'utils'
import { type ZodError, z } from 'zod'

import { useOrgCodeOrThrow } from '../features/active-operation'

const responseSchema = z.object({
  items: z.array(
    userAccountSchema.extend({
      userRoleType: roleTypeSchema
    })
  )
})

const queryFn = async (client: ApiClient, orgCode: string | undefined) => {
  throwIfNil(orgCode, 'cannot query a null organization')

  const { body } = await client.get(`/organizations/${orgCode}/useraccounts`)

  const data = responseSchema.parse(body)

  return data.items
}

type Result = Awaited<ReturnType<typeof queryFn>>

export type OperationUser = Result[number]

export const queryKey = 'operation-users-list'

export const useOperationUserList = ({ ignoreSupporters } = { ignoreSupporters: false }) => {
  const orgCode = useOrgCodeOrThrow()
  const apiClient = useApiClient()

  return useQuery<Result, ApiError | ZodError>({
    queryKey: [queryKey, orgCode],
    queryFn: () => queryFn(apiClient, orgCode),
    enabled: Boolean(orgCode),
    select: ignoreSupporters
      ? (data) => data.filter((o) => o.userRoleType !== RoleType.Supporter)
      : undefined
  })
}
